import {
  getAppearanceMode,
  getColorTheme,
  readStoredTheme,
  writeStoredTheme
} from '@/config/appThemes'
import { applyElementChalkTheme } from '@/utils/elementChalkTheme'

function hexToRgb(hex) {
  const h = String(hex || '').replace('#', '')
  if (h.length !== 6) return '64, 158, 255'
  const n = parseInt(h, 16)
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(', ')
}

function applyShellVars(theme) {
  const color = getColorTheme(theme.colorId)
  const mode = getAppearanceMode(theme.modeId)
  const root = document.documentElement

  root.setAttribute('data-theme-color', color.id)
  root.setAttribute('data-theme-mode', mode.id)

  root.style.setProperty('--app-primary', color.primary)
  root.style.setProperty('--app-primary-hover', color.primaryHover)
  root.style.setProperty('--app-primary-active', color.primaryActive)
  root.style.setProperty('--app-primary-light', color.primaryLight)
  root.style.setProperty('--app-primary-rgb', hexToRgb(color.primary))

  if (mode.id === 'eyecare') {
    root.style.setProperty('--app-page-bg', '#C7EDCC')
    root.style.setProperty('--app-aside-bg', '#3d5a45')
    root.style.setProperty('--app-main-bg', '#E4F5E7')
    root.style.setProperty('--app-card-bg', '#F0FAF2')
    root.style.setProperty('--app-text', '#2F3B2F')
    root.style.setProperty('--app-text-secondary', '#5A6B5A')
    root.style.setProperty('--app-border', '#A8D5B0')
    root.style.setProperty('--app-header-fg', '#FFFFFF')
    root.style.setProperty('--app-mask', 'rgba(40, 70, 45, 0.35)')
  } else {
    root.style.setProperty('--app-page-bg', '#F5F7FA')
    root.style.setProperty('--app-aside-bg', '#545c64')
    root.style.setProperty('--app-main-bg', '#FFFFFF')
    root.style.setProperty('--app-card-bg', '#FFFFFF')
    root.style.setProperty('--app-text', '#303133')
    root.style.setProperty('--app-text-secondary', '#909399')
    root.style.setProperty('--app-border', '#EBEEF5')
    root.style.setProperty('--app-header-fg', '#FFFFFF')
    root.style.setProperty('--app-mask', 'rgba(0, 0, 0, 0.35)')
  }

  return { colorId: color.id, modeId: mode.id, primary: color.primary }
}

export function applyAppTheme(theme) {
  const applied = applyShellVars(theme)
  applyElementChalkTheme(applied.primary).catch(() => {})
  return { colorId: applied.colorId, modeId: applied.modeId }
}

export function initAppTheme() {
  return applyAppTheme(readStoredTheme())
}

export function setAppTheme(partial) {
  const current = readStoredTheme()
  const next = writeStoredTheme({
    colorId: partial.colorId != null ? partial.colorId : current.colorId,
    modeId: partial.modeId != null ? partial.modeId : current.modeId
  })
  return applyAppTheme(next)
}
